// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__25CRq","icon":"SortAdornment_icon__2Mzx1","up":"SortAdornment_up__1ekdc","down":"SortAdornment_down__3RF54","active":"SortAdornment_active__70e9Z"};